import { Tag, TagProps } from "@carbon/react";
import React from "react";

import { useAlertValidationDecisions } from "src/hooks/alerts/useAlertValidationDecisions";
import { useFormatCurrency } from "src/internationalization";
import { AlertValidationDecision } from "src/types/alert";

const ALERT_VALIDATION_DECISION_COLORS: {
  [key in AlertValidationDecision]: TagProps<"div">["type"];
} = {
  compliant: "green",
  fraudPrevented: "blue",
  provenFraudWithFinancialLoss: "red",
  provenFraudWithNoFinancialLoss: "red",
};

export const AlertDecisionTag: React.FC<{
  decision: AlertValidationDecision;
  financialLossAmount?: number | null;
  preventedFraudAmount?: number | null;
}> = ({ decision, financialLossAmount, preventedFraudAmount }) => {
  const decisions = useAlertValidationDecisions();
  const decisionData = decisions.find((d) => d.id === decision);
  const formatCurrency = useFormatCurrency();

  if (!decisionData) {
    return null;
  }
  const amount = financialLossAmount || preventedFraudAmount;

  return (
    <Tag
      type={ALERT_VALIDATION_DECISION_COLORS[decision]}
      className="![max-inline-size:max-content]"
    >
      {decisionData.title}
      {amount && <span> • {formatCurrency(amount)}</span>}
    </Tag>
  );
};
